module.exports = __webpack_public_path__ + "img/imgyongzjq-1.3d9f7b66.png";